module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.14.0_gatsby@5.14.5_babel-eslint@10.1.0_eslint@9.32.0_jiti@1.21_1fcdaa9316f2712822a184e4806a856c/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"./src/images/icon.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0b308e106d4c2c9d8f9260af6c477912"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.5_babel-eslint@10.1.0_eslint@9.32.0_jiti@1.21.7___react-dom@18.3.1_react@18_be0a4be8546adc42bee259b0c3a122e1/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
